import clsx from 'clsx';
import React, { useState } from 'react';
// import { useRouter } from 'next/router';
import { NextPage /*, GetStaticProps*/ } from 'next';
import SEO from '@/components/head/Seo';
import Advertisers from '@/components/head/Advertisers';
import JsonSchemaPage from '@/components/jsonSchema/Page';
import JsonSchemaRating from '@/components/jsonSchema/Rating';
import envConfig from '@/config/environment';
import Nav from '@/components/navigation/Public';
import Hero from '@/components/heros/Calculator';
import Footer from '@/components/legal/Footer';
import SignUpForm from '@/components/forms/Newsletter';
import { useTrackPageViews, pageViewCounters } from '@/hooks/useTrackPageViews';
import { matt, kandice } from '@/content/authors';
import Article from '@/features/resources/RowingPaceCalculator/Article';
import settings from '@/features/resources/RowingPaceCalculator/settings';
import PrimaryWidget from '@/features/Calculators/PrimaryWidget';
import ReviewsModal from '@/components/reviews/ReviewsModal';
// import Advertisement from '../../features/Calculators/Advertisement';
import layoutStyles from '@/components/Layout/styles.module.scss';
import { titleize } from '@/utils/strings';

const IS_STAGING = envConfig.isStaging;
const IS_DEVELOPMENT = envConfig.isDevelopment;

// @ts-ignore
const Page: NextPage = () => {
  const authors = [kandice];
  const reviewers = [matt];
  const [, /*isPrimaryWidgetLoaded*/ setIsPrimaryWidgetLoaded] =
    useState(false);
  const [isViewingReviews, setIsViewingReviews] = useState(false);

  const reviews = settings.reviews || [];
  const primaryWidgetId =
    IS_DEVELOPMENT || IS_STAGING
      ? settings.widgets.primaryStaging
      : settings.widgets.primary;

  const reviewScore = parseFloat(
    (
      reviews.reduce((acc, { score }) => (acc += score), 0) /
      Math.max(reviews.length, 1)
    ).toFixed(1)
  );

  // Increment calculator page view
  useTrackPageViews(pageViewCounters.calculator);

  return (
    <>
      <SEO
        title={settings.title}
        description={settings.description}
        twitterImgSrc={`${envConfig.baseUrl}${settings.images.twitterPost}`}
        ogImageSrc={`${envConfig.baseUrl}${settings.images.openGraph}`}
      />
      <Advertisers />

      <div
        role="main"
        className={clsx(layoutStyles.main, '-bgc-white')}
        id="scroll-container"
      >
        <Nav />
        <Hero
          heading={settings.hero.heading}
          description={settings.hero.description}
          breadcrumbs={[
            {
              href: `/${settings.directory}`,
              text: titleize(settings.directory),
            },
            { text: 'Fitness' },
          ]}
          featuredImgSrcsets={settings.hero.featuredImgSrcsets}
          featuredImgAlt={settings.hero.featuredImgAlt}
          features={settings.hero.features}
          reviews={reviews}
          onReviewsClick={() => setIsViewingReviews(true)}
        />

        <PrimaryWidget
          widgetId={primaryWidgetId}
          elementId="primary"
          advertisement={false}
          name="rowingPace"
          onLoad={() => setIsPrimaryWidgetLoaded(true)}
        />

        <Article
          createdAt={settings.createdAt}
          updatedAt={settings.updatedAt}
          authors={authors}
          reviewers={reviewers}
        />

        <SignUpForm />
        <Footer />
      </div>

      <ReviewsModal
        isVisible={isViewingReviews}
        reviews={reviews}
        cta="Add Your Review"
        onClose={() => setIsViewingReviews(false)}
      />

      <JsonSchemaPage
        headline={settings.title}
        url={`/${settings.slug}`}
        // @ts-ignore
        type={settings?.jsonLd?.type}
        createdAt={settings.createdAt}
        updatedAt={settings.updatedAt}
        imgSrc={settings?.images?.openGraph}
        authors={authors}
        editors={reviewers}
      />

      {reviews && reviews.length ? (
        <JsonSchemaRating
          name={settings.heading}
          description={settings.description}
          ratingCount={reviews.length}
          ratingValue={reviewScore}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default Page;
